<template>
  <div class="title-container">
    <div class="title-content">
      <springText class="item-title" text="Character Attributes"></springText>
    </div>
    <fadeInAnimation>
      <div class="text-list">
        <div class="text-item">
          <div class="title">
            Reputation
          </div>
          <div class="sub-title">
            Determines the base amount of $FIRE a player can earn from matches.
          </div>
        </div>
        <div class="text-item">
          <div class="title">
            Luck
          </div>
          <div class="sub-title">
            Determines the base rate at which players can acquire bounty cases from matches.
          </div>
        </div>
        <div class="text-item">
          <div class="title">
            Efficiency
          </div>
          <div class="sub-title">
            Rewards players who perform better in games. The higher the match rating, the greater the $FIRE amount and
            bounty
            case earning rate.
          </div>
        </div>
        <div class="text-item">
          <div class="title">
            Tactics
          </div>
          <div class="sub-title">
            Measures the effective use of tactical items like EMPs to contribute to the team. Higher tactical
            performance
            scores increase the $FIRE amount and bounty case earning rate.
          </div>
        </div>
      </div>
    </fadeInAnimation>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import springText from "@/views/components/springText";
import fadeInAnimation from "@/views/components/fadeInAnimation";

export default {
  mixins: [responsiveMixin],
  components: { springText, fadeInAnimation },
  data() {
    return {};
  },
  mounted() { },
  methods: {},
  watch: {

  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>